import {
	Button,
	ClassNameProps,
	Column,
	Heading,
	If,
	makeClassName,
	Modal,
	ModalProps,
	Row,
	StyleProps,
} from "@hex-insights/core";
import { Icon } from "../../../../Components/Icon";
import { NewsletterLink } from "../../../Links";
import { DetailDisplayNewsletter, NewsletterDetailDisplay } from "../DetailDisplay";
import { ControlledIndividualStatisticsTile } from "../Statistics";
import styles from "./styles.module.css";

export type AdminModalNewsletter = DetailDisplayNewsletter;

export type NewsletterAdminModalProps = {
	newsletter: AdminModalNewsletter;
	withBackButton?: boolean;
} & Pick<ModalProps, "ifRef" | "onClose"> &
	Partial<ClassNameProps & StyleProps>;

export function NewsletterAdminModal({
	newsletter,
	withBackButton = false,
	ifRef,
	onClose,
	className,
	style,
}: NewsletterAdminModalProps) {
	return (
		<Modal ifRef={ifRef} size="large" onClose={onClose} className={className} style={style}>
			<Modal.Header>
				<Column justify="spaced-start" verticalSpacing="0.25rem">
					<If condition={withBackButton}>
						{onClose && (
							<Button variant="link" size="small" onClick={onClose}>
								<Row justify="spaced-start" align="center" horizontalSpacing="0.375rem">
									<Icon.ArrowLeft size={14} /> Back to Newsletters
								</Row>
							</Button>
						)}
					</If>

					<Heading.H2 noMargin>{newsletter.title}</Heading.H2>
				</Column>
			</Modal.Header>
			<Modal.Body>
				<NewsletterDetailDisplay newsletter={newsletter} withStatus withAudience editable />
			</Modal.Body>
			<Modal.Footer>
				<Row justify="space-between" align="center">
					<ControlledIndividualStatisticsTile newsletterID={newsletter.id} />

					<NewsletterLink
						instance={newsletter}
						className={makeClassName(styles["detail-link"], "link--no-text-decoration")}
					>
						<Row justify="spaced-start" align="center" horizontalSpacing="0.25rem">
							<span>View Page</span>
							<Icon.ArrowRight size={14} />
						</Row>
					</NewsletterLink>
				</Row>
			</Modal.Footer>
		</Modal>
	);
}
